import React, { useState } from 'react';

import Confetti from 'react-dom-confetti';

import CardWrap from '../Card/CardWrap';
import Card, { CardProps } from '../Card/Card';

import * as styles from './RevealCard.module.scss';
import { RARITY } from '../../data/characters';

interface RevealCardProps {
  onSelect: Function;
  initialFlipped?: boolean;
}

const RevealCard : React.FC<CardProps & RevealCardProps> = ({ onSelect, initialFlipped = true, ...card}) => {
  const [isFlipped, setFlipped] = useState(initialFlipped);

  const onCardClick = () => {
    if (isFlipped) {
      setFlipped(false)
    } else {
      onSelect(card.number);
    }
  };

  return (
    <div className={styles.wrap} onClick={() => onCardClick()}>
      { card.rarity === RARITY.RARE && (
        <div className={styles.confetti}>
          <Confetti active={ !isFlipped }/>
        </div>
      ) }
      <CardWrap width={200}>
        <Card {...card} flipped={isFlipped}/>
      </CardWrap>
    </div>
  )
};

export default RevealCard;
